function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.227 3.233a.76.76 0 011.008-.077l.087.077L8 10.083l6.678-6.85a.76.76 0 011.008-.077l.087.077a.81.81 0 01.075 1.034l-.075.089-7.226 7.411a.76.76 0 01-1.008.077l-.086-.077L.227 4.356a.807.807 0 010-1.123z",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    className: "arrow_svg__w-3 arrow_svg__h-3 arrow_svg__transform arrow_svg__mr-1 arrow_svg__md:h-6 arrow_svg__md:w-6"
  }, props), _ref);
}

export default SvgArrow;